module.exports = __webpack_public_path__ + "static/media/figure5_v2.8e30bb03.jpg";